import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Plans from './pages/Plans';
import AccountPage from './pages/Account';
import Dashboard from './pages/Dashboard';
import ChatAgent from './pages/ChatAgent';
import Charts from './pages/Charts';
import SubmissionDirectory from './pages/SubmissionDirectory';
import PricingTools from './pages/PricingTools';
import LandingPage from './pages/LandingPage';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import EbookPage from "./pages/ebook";
import FreeResources from "./pages/FreeResources";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import InsightsPage from "./pages/InsightsPage";
import ContactSupport from "./pages/ContactSupport";

function App() {
  return (
    <Router>
      <Routes>
  {/* Home */}
  <Route path="/" element={<LandingPage />} />

  {/* Marketing pages */}
  <Route path="/features" element={<Features />} />
  <Route path="/pricing" element={<Pricing />} />
  <Route path="/ebook" element={<EbookPage />} />
  <Route path="/checkout/success" element={<CheckoutSuccess />} />
  <Route path="/checkout/cancel" element={<CheckoutCancel />} />

  {/* Auth / app */}
  <Route path="/signup" element={<Register />} />   {/* alias for Register */}
  <Route path="/login" element={<Login />} />
  <Route path="/register" element={<Register />} />
  <Route path="/plans" element={<Plans />} />
  <Route path="/account" element={<AccountPage />} />
  <Route path="/dashboard" element={<Dashboard />} />
  <Route path="/forgot-password" element={<ForgotPassword />} />
  <Route path="/reset-password" element={<ResetPassword />} />
  <Route path="/terms" element={<TermsPage />} />
  <Route path="/privacy" element={<PrivacyPage />} />


  {/* Product sections */}
  <Route path="/advisors" element={<ChatAgent />} />
  <Route path="/charts" element={<Charts />} />
  <Route path="/submission-directory" element={<SubmissionDirectory />} />
  <Route path="/pricing-tools" element={<PricingTools />} />
  <Route path="/free-resources" element={<FreeResources />} />
  <Route path="/insights" element={<InsightsPage />} />
  <Route path="/contact-support" element={<ContactSupport />} />

  {/* Optional extras */}
  <Route path="/landing-page" element={<LandingPage />} /> {/* optional alias for old links */}
  <Route path="/contact" element={<Contact />} />

  {/* 404 */}
  <Route path="*" element={<NotFound />} />
</Routes>
    </Router>
  );
}

export default App;
